import { MARK_PATH, MARK_VIEWBOX } from "./paths";
import {
  INK_COLOR,
  TILE_COLOR,
  type BrandColor,
  type BrandVariant,
} from "./tokens";

export interface AdvaMarkProps {
  size?: number;
  color?: BrandColor;
  variant?: BrandVariant;
  className?: string;
  title?: string;
  "aria-label"?: string;
}

export function AdvaMark({
  size = 24,
  color = "dark",
  variant = "transparent",
  className,
  title,
  "aria-label": ariaLabel,
}: AdvaMarkProps) {
  const accessibleName = ariaLabel ?? title ?? "Adva mark";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={MARK_VIEWBOX}
      width={size}
      height={size}
      fillRule="evenodd"
      role="img"
      aria-label={accessibleName}
      className={className}
    >
      {title ? <title>{title}</title> : null}
      {variant === "solid" ? (
        <rect width="100" height="100" fill={TILE_COLOR[color]} />
      ) : null}
      <path d={MARK_PATH} fill={INK_COLOR[color]} />
    </svg>
  );
}
